import { gql } from "apollo-boost";

const userActivities = gql`
  query ($filter: UserActivityFilter) {
    userActivities(filter: $filter) {
      total
      items {
        id
        title
        status
        category
        amount
        createDate
        sender
        senderId
        interested
        waitList
        otherRequest
      }
    }
  }
`;

const psOrder = gql`
  fragment psOrderInfo on PsOrder {
    OrderId
    Type
    RequestOrOffer
    Status
    Notes
    CreatedAt
    UpdatedAt
    category
    title
    Recipients {
      community {
        id
        name
      }
      group {
        id
        name
      }
      friend {
        id
        name
      }
    }
    CostAndSave {
      cost {
        total
        per
      }
    }
    sender {
      id
      name
    }
    consumer {
      id
      name
    }
    producer {
      id
      name
    }
    consumerChildren {
      name
    }
    services {
      Status
      StartTime
      Timezone
      Cost
      Consumer {
        id
        rate
      }
      Producer {
        id
        rate
      }
    }
  }
`;

const carpoolRequest = gql`
  query ($id: String!) {
    userActivity(id: $id) {
      ...psOrderInfo
      ShareDetail {
        ... on CarpoolRequest {
          type
          schedule
          pickUpTime
          timeToReturn
          pickUpPlace {
            displayAddress
          }
          dropOffPlace {
            displayAddress
          }
        }
      }
    }
  }
  ${psOrder}
`;

const childcareRequest = gql`
  query ($id: String!) {
    userActivity(id: $id) {
      ...psOrderInfo
      ShareDetail {
        ... on ChildcareRequest {
          schedule
          shareType
          locationType
          giverType
          startTime
          endTime
          addr
        }
      }
    }
  }
  ${psOrder}
`;

const uShareRequest = gql`
  query ($id: String!) {
    userActivity(id: $id) {
      ...psOrderInfo
      ShareDetail {
        ... on UShareRequest {
          title
          description
          schedule
          fareType
          fare
          startTime
          endTime
          timezone
          pics {
            thumbnail
          }
          locationType
          addr
          daysNeeded
          receiving
        }
      }
    }
  }
  ${psOrder}
`;

const carpoolOffer = gql`
  query ($id: String!) {
    userActivity(id: $id) {
      ...psOrderInfo
      ShareDetail {
        ... on CarpoolOffer {
          schedule
          pickUpPlace {
            displayAddress
          }
          dropOffPlace {
            displayAddress
          }
          timezone
          availableSeats
          offering
          startTime
          endTime
          type
          option
        }
      }
    }
  }
  ${psOrder}
`;

const uShareOffer = gql`
  query ($id: String!) {
    userActivity(id: $id) {
      ...psOrderInfo
      ShareDetail {
        ... on UShareOffer {
          title
          description
          schedule
          startTime
          endTime
          timezone
          locationType
          addr
          offering
          offeringDetails {
            description
            fareType
            fare
            pic {
              thumbnail
            }
          }
        }
      }
    }
  }
  ${psOrder}
`;

const eduShareOffer = gql`
  query ($id: String!) {
    userActivity(id: $id) {
      ...psOrderInfo
      ShareDetail {
        ... on EduShareOffer {
          className
          description
          schedule
          startTime
          endTime
          timezone
          frequency
          addr
          offering
          fare
          capacity
          pic {
            thumbnail
          }
        }
      }
      banner {
        id
        type
        state
        note
        startTime
        endTime
        eduShareOffer {
          id
          title
          summary
          price
          originalPrice
        }
      }
    }
  }
  ${psOrder}
`;

const userActivity = gql`
  query ($id: String!) {
    userActivity(id: $id) {
      ...psOrderInfo
    }
  }
  ${psOrder}
`;

const eduShareStats = gql`
  query ($id: String!) {
    eduShareStats(id: $id) {
      anonInterested
      anonWaitList
      interested {
        id
        name
        mobile
        email
      }
      waitList {
        id
        name
        mobile
        email
      }
    }
  }
`;

export const userActivitiesGql = {
  userActivities,
  userActivity,
  carpoolRequest,
  childcareRequest,
  uShareRequest,
  uShareOffer,
  carpoolOffer,
  eduShareOffer,
  eduShareStats,
};
